export const setRootStyle = (name: string, value: string | null) => {
  window.document.documentElement.style.setProperty(name, value);
};
